<template>
  <StaffLayout section="Custom Content">
    <div class="mt-4">
      <div v-if="isLoading"><Loading /></div>
      <div v-else>
        <!-- <select
          v-model="selectedContentType"
          class="block w-full px-4 py-3 pr-8 mt-1 bg-gray-100"
          @change="contentTypeChanged($event.target as HTMLSelectElement)"
        >
          <option :value="ContentType.None">Select Content Type</option>
          <option :value="ContentType.HomePageHeader">Home Page Header</option>
          <option :value="ContentType.TrainingDescription">Training description</option>
          <option :value="ContentType.RespondHeader">Respond Header</option>
        </select>

        <div
          class="edit-panel-container mt-8 border p-4"
          v-if="selectedContentType !== ContentType.None"
        >
          <div v-if="error" class="text-red-500">{{ error }}</div>
          <div v-if="saveSuccessful" class="text-green-500">
            Content saved successfully
          </div>

          <div
            class="home-page-header"
            v-if="selectedContentType === ContentType.HomePageHeader"
          >
            <h1 class="text-lg font-bold pt-4">Home Page Header</h1>
            <h3 class="ml-2 mb-4 text-sm font-serif">
              Default Value: "Welcome to the Building"
            </h3>

            <BaseInput label="Custom Header Text:" v-model="contentValue" />
          </div>

        
          <div
            class="respond-edit-panel"
            v-if="selectedContentType === ContentType.RespondHeader"
          >
            <h1 class="text-lg font-bold pt-4">Home Page Respond Section Header</h1>
            <h3 class="ml-2 mb-4 text-sm font-serif">Default Value: "Response Steps"</h3>
            <img
              class="border border-gray-200 m-8 shadow-lg"
              src="/images/Custom_Response_header_screenshot.png"
              alt=""
            />
            <BaseInput label="Custom Header Text:" v-model="contentValue" />
          </div>

    
          <div
            class="training-description"
            v-if="selectedContentType === ContentType.TrainingDescription"
          >
            <h1 class="text-lg font-bold pt-4">Training Description</h1>
            <h3 class="ml-2 mb-4 text-sm font-serif">
              Default Value: "Please complete the following training"
            </h3>

            <BaseInput label="Custom Header Text:" v-model="contentValue" />
          </div>

          <div class="flex mt-8">
            <button
              type="button"
              class="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 bg-red-100 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
              @click="resetContent"
            >
              Reset to Default
            </button>
            <span class="flex-grow"></span>
            <button
              type="button"
              class="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 bg-blue-100 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
              @click="saveContent"
            >
              Save
            </button>
          </div>
        </div> -->

        <div class="m-auto bg-blue-900 w-full text-white text-center text-4xl py-5">
          More Features Coming Soon!
        </div>
      </div>
    </div>
  </StaffLayout>
</template>

<script setup lang="ts">
import { useBldgStore } from "../../store/bldgStore";
//import { ContentType, PortalContentDTO } from "../../store/generatedFetchClient";
const bldgStore = useBldgStore();

var property = computed(() => bldgStore.property);
var isLoading = computed(() => bldgStore.isLoading);
// var selectedContentType = ref(ContentType.RespondHeader);
// var contentValue = ref("");
// var error = ref("");
// var saveSuccessful = ref(false);

onMounted(loadData);
watch(() => property.value, loadData);
function loadData() {
  // if (property.value?.content && selectedContentType?.value) {
  //   contentValue.value = getContent(selectedContentType.value)?.contentValue;
  // }
}

// function contentTypeChanged(target: HTMLSelectElement) {
//   saveSuccessful.value = false;
//   selectedContentType.value = parseInt(target.value);
//   contentValue.value = getContent(selectedContentType.value)?.contentValue;
// }
// function getContent(contentType: ContentType) {
//   if (property?.value?.content) {
//     return property.value.content.find((c) => c.contentType === contentType);
//   }
//   return null;
// }

// async function saveContent() {
//   error.value = "";
//   saveSuccessful.value = false;
//   console.log(`saving content ${selectedContentType.value}: ${contentValue.value}`);
//   var content = getContent(selectedContentType.value);
//   if (!content) {
//     content = {
//       contentType: selectedContentType.value,
//       isStoredExternally: false,
//       mimeType: "text/plain",
//     } as PortalContentDTO;
//   }
//   content.contentValue = contentValue.value;
//   Object.assign(content, { portalId: property.value.portalId });

//   var saveResult = await bldgStore.saveContent(content);
//   if (!saveResult) {
//     console.log("content saved");
//     saveSuccessful.value = true;
//   } else {
//     console.error("content save failed with message: ", saveResult);
//     error.value = saveResult;
//   }
// }

// async function resetContent() {
//   console.log("reset content");
//   var content = getContent(selectedContentType.value);
//   var saveResult = await bldgStore.deleteContent(content.contentId);
//   if (!saveResult) {
//     console.log("content reset");
//     saveSuccessful.value = true;
//     contentValue.value = "";
//   } else {
//     console.error("content reset failed with message: ", saveResult);
//     error.value = saveResult;
//   }
// }
</script>
